module.exports = __webpack_public_path__ + "img/covidcover-old.9b122578.webp";